import { createRouter, createWebHashHistory } from 'vue-router'

import PageHome from '@/views/PageHome.vue'
import Berita from '@/views/berita/BeritaOPD.vue'
import isi_berita from '@/views/berita/isi_berita.vue'
import ProfilKantor from '@/views/profil/ProfilKantor.vue'
import ProfilDewan from '@/views/profil/ProfilDewan.vue'
import AlatDewan from '@/views/profil/AlatDewan.vue'
import StrukturOrganisasi from '@/views/profil/StrukturOrganisasi.vue'
import ProfilPegawai from '@/views/profil/ProfilPegawai.vue'



import FraksiFraksi from '@/views/fraksi/FraksiFraksi.vue'



import KomisiKomisi from '@/views/komisi/KomisiKomisi.vue'



import DataDokumen from '@/views/data/DataDokumen.vue'
import DataLainnya from '@/views/data/DataLainnya.vue'
import DataJDIH from '@/views/data/DataJDIH.vue'


import FotoOPD from '@/views/galeri/FotoOPD.vue'
import VideoOPD from '@/views/galeri/VideoOPD.vue'

const routes = [
  { path: '/', name: 'home', component: PageHome },
  { path: '/BeritaOPD', name: 'berita', component: Berita },
  { path: '/isi_berita', name: 'isi_berita', component: isi_berita },
  { path: '/ProfilKantor', name: 'ProfilKantor', component: ProfilKantor },
  { path: '/ProfilDewan', name: 'ProfilDewan', component: ProfilDewan },
  { path: '/AlatDewan', name: 'AlatDewan', component: AlatDewan },
  { path: '/StrukturOrganisasi', name: 'StrukturOrganisasi', component: StrukturOrganisasi },
  { path: '/ProfilPegawai', name: 'ProfilPegawai', component: ProfilPegawai },


  { path: '/FraksiFraksi', name: 'FraksiFraksi', component: FraksiFraksi },


  { path: '/KomisiKomisi', name: 'KomisiKomisi', component: KomisiKomisi },



  { path: '/DataDokumen', name: 'DataDokumen', component: DataDokumen },
  { path: '/DataLainnya', name: 'DataLainnya', component: DataLainnya },
  { path: '/DataJDIH', name: 'DataJDIH', component: DataJDIH },
 


  { path: '/FotoOPD', name: 'FotoOPD', component: FotoOPD },
  { path: '/VideoOPD', name: 'VideoOPD', component: VideoOPD },
]

const router = createRouter({
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(),
  routes,
})

export default router
